import i18next from "i18next";
import { getDirection } from "src/i18n/direction";

export class LanguageService {
  static changeLanguage(langKey: "ar" | "en") {
    i18next
      .changeLanguage(langKey)
      .then(() => {
        LanguageService.changeDocumentLanguageAttributes();
       // store.dispatch(BaseApi.util.resetApiState());
      });
  }
  static switchLanguage() {
    const langKey = i18next.language === "en" ? "ar" : "en";
    LanguageService.changeLanguage(langKey);
  }
  static changeDocumentLanguageAttributes() {
    document.documentElement.dir = getDirection(i18next.language);
    document.documentElement.lang = i18next.language;
  }
}
